import { atom } from 'jotai';
import { v4 as uuidv4 } from 'uuid';
import localforage from 'localforage';
import { ITranslation } from '../../Services/LanguageService';
import { localForageEffect } from './effects/localForageEffect';
import { setGdprSettingsToSocketServerEffect } from './effects/setGdprSettingsToSocketServerEffect';

// System loader state
export const setLoaderAtom = atom<boolean>(false);

// Form page detection - initialized from IndexedDB (same as Recoil version)
const initOnPageWithForm = async () => {
  const saved = await localforage.getItem<boolean>('onPageWithForm');
  return saved ?? false;
};

export const onPageWithFormAtom = atom<boolean | Promise<boolean>>(initOnPageWithForm());

// Effect for persisting onPageWithForm to IndexedDB
export const onPageWithFormEffectAtom = localForageEffect(onPageWithFormAtom, 'onPageWithForm');

// Browser tab identifier - never changes after initialization
export const browserTabIdAtom = atom<string>(uuidv4());

// GDPR settings - initialized from IndexedDB (default is [] not {} to match Recoil)
const initGdprSettings = async () => {
  const saved = await localforage.getItem<any[]>('gdprSettings');
  return saved || [];
};

export const gdprSettingsAtom = atom<any[] | Promise<any[]>>(initGdprSettings());

// Effects for gdprSettings: persist to IndexedDB and send to socket server
export const gdprSettingsLocalForageEffectAtom = localForageEffect(
  gdprSettingsAtom,
  'gdprSettings'
);
export const gdprSettingsSocketEffectAtom = setGdprSettingsToSocketServerEffect(gdprSettingsAtom);

// Locale strings for translations
export const localeStringsAtom = atom<ITranslation>({});
